<template>
    <div class="email-parent fl w-100 pt1 pt0-ns pb0">
        <div class="w-100 mb3 dib">
            <div class="f4 fw7 db mb3 tc-ns tl pb1">Or invite friends directly:</div>
            <div class="email-input-group fl w-100 right mb1">
                <label for="name" class="f55 db black-80 pb1">Your Name:</label>

                <input v-if="name.error.length == 0" v-model="name.value" id="name" name="name" type="text" placeholder="Enter your name..." class="mw-100 sans-serif w-100 fw4 f5 black-80 input-reset bg-white-ns bg-black-10 pv35 mr1 mb1 mb0-ns border-box ph3 share db">
                <input v-else v-model="name.value" id="name" name="name" type="text" placeholder="Enter your name..." class="mw-100 sans-serif w-100 fw4 f5 black-80 input-reset bg-white-ns bg-black-10 pv35 mr1 mb1 mb0-ns border-box ph3 share db error-input">

                <p v-if="name.error.length > 0" class="f6 email-octopus-error-message red">{{ name.error }}</p>
            </div>
        </div>
        <div class="email-input-group w-100 mb4">
            <label for="sendList" class="f55 db black-80 pb1">Send to (separate emails by comma):</label>

            <input v-if="sendList.error.length == 0" v-model="sendList.value" id="sendList" name="sendList" type="text" placeholder="Enter friends' emails..." class="mw-100 sans-serif w-100 fw4 f5 black-80 input-reset bg-white-ns bg-black-10 pv35 mr1 mb3 mb0-ns border-box ph3 share ma0 db">
            <input v-else v-model="sendList.value" id="sendList" name="sendList" type="text" placeholder="Enter friends' emails..." class="mw-100 sans-serif w-100 fw4 f5 black-80 input-reset bg-white-ns bg-black-10 pv35 mr1 mb3 mb0-ns border-box ph3 share ma0 db error-input">

            <p v-if="sendList.error.length > 0" class="f6 email-octopus-error-message red">{{ sendList.error }}</p>
        </div>
        <div class="relative dib w-100">
            <button v-on:click="sendEmail()" class="fw7 f55 sans-serif button-reset pv35 ph35-ns h-100 tc bg-black-90 bn white pointer w-100 ambassador-btn copy-btn">Send Invites →</button>
            <div id="sk-ref-parent" class="absolute">
                <div class="sk-double-bounce dib">
                    <div class="sk-child sk-double-bounce1 dib"></div>
                    <div class="sk-child sk-double-bounce2 dib"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from 'request';
import util from '../util.js';

export default {
    props: {
        user: Object
    },
    data() {
        return {
            name: {
                value: "",
                error: ""
            },
            sendList: {
                value: "",
                error: ""
            },
            state: "",
            userObj: {
                email: this.user.email,
                uid: this.user.uid
            }
        }
    },
    methods: {
        sendEmail() {
            $("#sk-ref-parent").css('display', 'inline-block');
            var self = this;

            let refLink = $("#refer-link").val();
            var emails = this.sendList.value.replace(/\s/g,'').split(",");

            this.clearErrors();
            if (this.validateInputs(emails)) {
                var options = {
                    url: process.env.HOME_API + "/api/referral/email",
                    method: 'POST',
                    json: true,
                    body: {
                        user: this.userObj.email,
                        userid: this.userObj.uid,
                        name: this.name,
                        sendList: JSON.stringify(emails),
                        refLink: refLink
                    },
                }

                request(options, function (error, response, body) {
                    $("#sk-ref-parent").hide();
                    if (_.isUndefined(response)) {
                        this.state = "Server might be down. Please check again later.";
                    } else {
                        self.$cookies.set("message", "Thanks for sending out some referrals. When they sign up you'll see your referral count increase.", 15);
                        window.location.href = "/ambassador/";
                    }
                    
                });
            } else {
                $("#sk-ref-parent").hide();
                return false;
            }
        },

        validateInputs(emails) {
            let validEmailList = this.validEmailList(emails);
            let validName = this.validName(this.name.value);

            if (validEmailList && validName) {
                return true;
            } else {
                if (!validName) this.name.error = "Name is required.";

                if (!validEmailList) this.sendList.error = "We think there may be a problem with this email list. Please check it and try again.";

                return false;
            }
        },

        validEmailList(emails) {
            for (var i = 0; i < emails.length; i++) {
                if( emails[i] == "" || ! util.validEmail(emails[i])){
                    return false;
                }
            }
            return true;
        },

        validName(name) {
            if (name !== "") {
                return true;
            } else {
                return false;
            }
        },

        clearErrors() {
            this.name.error = "";
            this.sendList.error = "";
        }
    },
    watch: {
        user: {
            handler(newUser, oldUser) {
                this.userObj = newUser;
            },
            deep: true
        }
    }
}
</script>



// WEBPACK FOOTER //
// _vue/components/SendReferral.vue